import { render, staticRenderFns } from "./HobbiesComponent.vue?vue&type=template&id=fdd5297c"
import script from "./HobbiesComponent.vue?vue&type=script&lang=ts"
export * from "./HobbiesComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports